import * as actionType from '../action-type';

const initialState = {
  data: {},
};

const carpetBasicReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_CARPET_BASIC_REPORT:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case actionType.RESET_CARPET_BASIC_REPORT:
      return initialState;
    default:
      return state;
  }
};

export default carpetBasicReportReducer;
